import React from 'react';

const SO_COOKIES = [
  // 'campaign',
  'cart',
  'auth',
  'clubMembershipCart'
];

const getQueryString = () => {
  return (document.cookie || '')
    .split(';')
    .map(a => {
      const [name, value] = (a || '').split('=');
      return {
        name: (name || '').trim(),
        value: (value || '').trim()
      };
    })
    .filter(({ name }) => SO_COOKIES.some(s => s === name))
    .map(({ name, value }) => `${name}=${value}`)
    .join('&');
};

const onClick = e => {
  e.preventDefault();
  const qs = getQueryString();

  const { target } = e || {};
  const { href } = target || {};
  window.location = `${href}?${qs}`;
};

const CookieLink = (
  {
    href,
    render,
    label,
    ...rest
  }
) => {
  if (render) return render({ onClick });

  return (
    <a href={href} onClick={onClick} {...rest}>
      {label}
    </a>
  );
};

export default CookieLink;

export const handleCookieNav = (href, query) => {
  const qs = query ? `${getQueryString()}&${query}` : getQueryString();
  window.location = `${href}?${qs}`;
};
